import gql from 'graphql-tag'
// change this to MutationFunction when apollo is updated
import { MutationFunction } from 'react-apollo'
import {
  CreateGatheringRegistration,
  CreateGatheringRegistrationVariables,
} from './__generated__/CreateGatheringRegistration'

export const CREATE_GATHERING_REGISTRATION_MUTATION = gql`
  mutation CreateGatheringRegistration(
    $gatheringId: Int!
    $gatheringRegistration: GatheringRegistrationParams!
    $password: String
    $child: CreateGatheringRegistrationChildParams
  ) {
    createGatheringRegistration(
      gatheringId: $gatheringId
      gatheringRegistration: $gatheringRegistration
      password: $password
      child: $child
    ) {
      id
      quantity
    }
  }
`
export type CreateGatheringRegistrationMutationFn = MutationFunction<
  CreateGatheringRegistration,
  CreateGatheringRegistrationVariables
>
